{
    "PlaysoundLabel": "Reproduzir som (requer leitor de multimédia local):",
    "ActivewindowLabel": "Janela ativa (apenas browsers IE\/Firefox com separador único):",
    "AlarmActions_SectionHeader": "Ações de alarme",
    "AlarmActions_SectionPara": "Quando os alarmes forem ativados, a linha correspondente do relatório e\/ou as estatísticas irão piscar. Abaixo, pode escolher ações adicionais que ocorrem para o relatório atualmente ativo quando um dos seus alarmes começa a ser acionado pela primeira vez.",
    "NAME": "AlarmActions"
}